<template>
  <div>
    <h4 class="title">PDF</h4>
    <div class="field">
      <label class="label"> फाइलको नाम</label>
      <div class="control">
        <input
          class="input"
          v-model="form.name"
          type="text"
          placeholder="फाइलको नाम"
          :class="{ 'is-danger': errors.name }"
        />
        <p class="help is-danger" v-if="errors.name">फाइलको नाम आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <label class="label">फाइल</label>
      <div class="control">
        <div class="file has-name">
          <label class="file-label">
            <input class="file-input" type="file" ref="file" @change="upload" />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label"> Choose a file… </span>
            </span>
            <span class="file-name" style="min-width: 218px">
              {{ fileName }}
            </span>
          </label>
        </div>
        <p class="help is-danger" v-if="errors.pdf">फाइल आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <label class="label">फोटो</label>
      <div class="control">
        <div class="file has-name">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              ref="photo"
              @change="uploadPhoto"
              accept=".jpg,.jpeg,.png"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label"> Choose a file </span>
            </span>
            <span class="file-name" style="min-width: 230px">
              {{ photoName }}
            </span>
          </label>
        </div>
        <p class="help is-danger" v-if="errors.image">फोटो आवश्यक छ।</p>
        <p class="help is-danger" v-if="errors.imageFormat">
          Only JPG, JPEG, and PNG files are allowed
        </p>
      </div>
    </div>
    <button
      class="button submit pbutton"
      :class="{ 'is-loading': loading }"
      @click="validate(savepdf)"
      v-if="edit == false"
    >
      सेभ गर्नुहोस
    </button>
    <button
      class="button submit pbutton"
      :class="{ 'is-loading': loading }"
      @click="validate(updatePdf)"
      v-else
    >
      अपडेट गर्नुहोस्
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "../../main";
export default {
  data() {
    return {
      fileName: "",
      photoName: "",
      form: {
        name: "",
        pdf: null,
        image: null,
      },
      loading: false,
      pdfData: {},
      edit: false,
      errors: {
        name: false,
        pdf: false,
        image: false,
        imageFormat: false,
      },
    };
  },
  created() {
    bus.$on("edit-pdf", (e) => {
      this.edit = true;
      this.form = e;
      this.fileName = this.form.pdf;
      this.photoName = this.form.image;
    });
  },
  methods: {
    clearForm() {
      this.form = {
        name: "",
        pdf: null,
        image: null,
      };
      this.fileName = "";
      this.photoName = "";
      this.errors = {
        name: false,
        pdf: false,
        image: false,
        imageFormat: false,
      };
    },
    uploadPhoto(event) {
      const file = this.$refs.photo.files[0];
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

      if (file && allowedTypes.includes(file.type)) {
        this.photoName = file.name;
        this.form.image = file;
        this.errors.imageFormat = false;
        this.errors.image = false;
      } else {
        this.photoName = "";
        this.form.image = null;
        this.errors.imageFormat = true;
        this.$refs.photo.value = "";
      }
    },
    upload() {
      const file = this.$refs.file.files[0];
      if (file) {
        this.fileName = file.name;
        this.form.pdf = file;
        this.errors.pdf = false;
      }
    },
    validate(callback) {
      this.errors = {
        name: !this.form.name,
        pdf: !this.form.pdf,
        image: !this.form.image,
        imageFormat: false,
      };

      if (
        !this.errors.name &&
        !this.errors.pdf &&
        !this.errors.image &&
        !this.errors.imageFormat
      ) {
        callback();
      }
    },
    updatePdf() {
      this.loading = true;
      const fd = new FormData();
      fd.append("name", this.form.name);
      fd.append("pdf", this.form.pdf);
      fd.append("image", this.form.image);
      axios
        .post("api/pdf/update/" + this.form.id , fd)
        .then((res) => {
          this.loading = false;
          this.$notify.success({
            position: "bottom right",
            msg: "PDF updated successfully!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
          this.clearForm();
          bus.$emit("pdf", true);
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.error({
            position: "bottom right",
            msg: "PDF could not be updated!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
        });
    },
    savepdf() {
      this.loading = true;
      const fd = new FormData();
      fd.append("name", this.form.name);
      fd.append("pdf", this.form.pdf);
      fd.append("image", this.form.image);
      axios
        .post("/api/store-calendar-pdfs", fd)
        .then((res) => {
          this.loading = false;
          this.$notify.success({
            position: "bottom right",
            msg: "PDF added successfully!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
          this.clearForm();
          bus.$emit("pdf", true);
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.error({
            position: "bottom right",
            msg: "PDF could not be stored!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.label {
  color: #6a6a6a;
  font-weight: 400;
}
.title {
  font-size: 1.5rem;
  margin-bottom: 0px;
  color: #254594;
  margin-bottom: 10px;
}
.pbutton {
  background: #254594;
  color: #fff;
  border-radius: 34px;
  width: 153px;
  height: 40px;
  margin-top: 30px;
}
.pbutton:hover {
  color: #fff;
}
.pbutton:focus {
  color: #fff;
}
.is-danger {
  border-color: #f14668;
}
</style>
